var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('div',{attrs:{"id":"pie2"}}),_vm._v(" "),_c('div',{attrs:{"id":"zongzichan"}},[_c('span',[_vm._v("总资产")]),_c('b',[_vm._v(_vm._s(_vm.all)+"台")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-760e01c5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/kanban/abc/pie.vue
// module id = null
// module chunks = 